import { render, staticRenderFns } from "./ExtrusionDeliveryForm.vue?vue&type=template&id=2d0caa66&scoped=true"
import script from "./ExtrusionDeliveryForm.vue?vue&type=script&lang=js"
export * from "./ExtrusionDeliveryForm.vue?vue&type=script&lang=js"
import style0 from "./ExtrusionDeliveryForm.vue?vue&type=style&index=0&id=2d0caa66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0caa66",
  null
  
)

export default component.exports